<template>
  <v-app>
    <un-notifications-queue />
    <routerView/>
  </v-app>
</template>

<script>
import UnNotificationsQueue from '@ulibs/unnotificationsqueue';

export default {
  name: 'App',
  components: { UnNotificationsQueue }
};
</script>

<style lang="scss">
  @import "~@/styles/normalize.css";
</style>
